<template>

    <slot></slot>
    <div :class="['layout-mask', { 'layout-mask-active': sidebarActive }]" @click="onMaskClick"></div>
    <div class="md:hidden">
      <AppSidebar :active="sidebarActive"/>
    </div>
<!--    <Toast position="top-center" />
    <Toast position="top-left" group="tl"/>
    <Toast position="bottom-left" group="bl" />
    <Toast position="bottom-right" group="br" />
    <Toast position="top-center" group="tc" />-->
</template>
<script setup lang="ts">
import EventBus from '@/components/app/AppEventBus';
import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { blockBodyScroll, unblockBodyScroll } from '@primeuix/utils/dom';

const nuxtApp = useNuxtApp();
const sidebarActive = ref(false);
const route = useRoute();

// Listen for EventBus events when the component is mounted
onMounted(() => {
  EventBus.on('main-menu-clicked', handleMenuClick);
});

// Clean up when the component is unmounted
onUnmounted(() => {
  EventBus.off('main-menu-clicked', handleMenuClick);
});

const handleMenuClick = (): void => {
  onMenuButtonClick();
};

const onMenuButtonClick = (): void => {
  if (sidebarActive.value) {
    sidebarActive.value = false;
    unblockBodyScroll('blocked-scroll');
  } else {
    sidebarActive.value = true;
    blockBodyScroll('blocked-scroll');
  }
};

const onMaskClick = (): void => {
  sidebarActive.value = false;
  unblockBodyScroll('blocked-scroll');
};

const isOutdatedIE = (): boolean => {
  const ua = window.navigator.userAgent;
  return ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
};

const containerClass = computed(() => ['app-layout']);

const pageBackground = computed(() => {
  return route.query.bgColor || 'bg-primary-bg';
});

watch(
  () => route.path,
  () => {
    if (typeof window === 'undefined') {
      return;
    }
    sidebarActive.value = false;
    unblockBodyScroll('blocked-scroll');
    // nuxtApp.$appState.toast.removeAllGroups();
  },
  { immediate: true }
);
</script>

